import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import zhCN from './lang/zh-CN.json'
import zhTW from './lang/zh-TW.json'
import enUS from './lang/en-US.json'

function getPersistedLocale(): string | undefined {
  try {
    const raw = localStorage.getItem('i18n-storage')
    if (raw) {
      const parsed = JSON.parse(raw)
      const locale = parsed?.state?.locale
      if (locale === 'zh-CN' || locale === 'zh-TW' || locale === 'en-US') return locale
    }
  } catch {
    // ignore
  }
  return undefined
}

function getBrowserLocale(): string {
  const lang = (navigator.language || '').toLowerCase()
  if (lang.startsWith('zh-tw') || lang.startsWith('zh-hk') || lang.startsWith('zh-mo'))
    return 'zh-TW'
  if (lang.startsWith('zh-cn') || lang.startsWith('zh-sg') || lang.startsWith('zh-my'))
    return 'zh-CN'
  if (lang.startsWith('zh')) return 'zh-TW'
  return 'en-US'
}

const initialLocale = getPersistedLocale() ?? getBrowserLocale()

i18n.use(initReactI18next).init({
  resources: {
    'zh-CN': { translation: zhCN },
    'zh-TW': { translation: zhTW },
    'en-US': { translation: enUS },
  },
  lng: initialLocale,
  fallbackLng: 'zh-TW',
  defaultNS: 'translation',
  interpolation: { escapeValue: false },
})

export default i18n
